module.exports = __webpack_public_path__ + "img/avatar-example.8336313b.png";